export default "__VITE_ASSET__CNIv2eCn__"